<template>
	<section>
		<div class="row field">
			<div class="col-md-12">
				<fieldset>
					<div class="field-title">
						<div class="legend">
							Horários para saldação
						</div>
					</div>

					<div class="container-fluid">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
				                    <label  for="hdia">Bom dia:</label>
				                    <input type="time" v-model="params.HDIA" class="form-control">
				                </div>
							</div>

							<div class="col-md-4">
								<div class="form-group">
				                    <label  for="htarde">Boa tarde:</label>
				                    <input type="time" v-model="params.HTARDE" class="form-control">
				                </div>
							</div>

							<div class="col-md-4">
								<div class="form-group">
				                    <label  for="hnoite">Boa noite:</label>
				                    <input type="time" v-model="params.HNOITE" class="form-control">
				                </div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
		</div>

		<div class="row field">
			<div class="col-md-12">
				<fieldset>
					<div class="field-title">
						<div class="legend">
							Volume
						</div>
					</div>

					<div class="container-fluid">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
				                    <label  for="voltxligacao">Ligações TX: ( saída de áudio )</label>
				                    <input type="range" min="1" max="9" v-model="params.VOL_TX" class="form-control slider">
				                </div>
							</div>

							<div class="col-md-4">
								<div class="form-group">
				                    <label  for="volrxligacao">Ligações RX: ( entrada de áudio )</label>
				                    <input type="range" min="1" max="9" v-model="params.VOL_RX" class="form-control slider">
				                </div>
							</div>

							<div class="col-md-4">
								<div class="form-group">
				                    <label  for="volrxdenuncia">Denúncia:</label>
				                    <input type="range" min="1" max="9" v-model="params.VOL_DEN" class="form-control slider">
				                </div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
		</div>
		
		<div class="row field">
			<div class="col-md-12">
				<fieldset>
					<div class="field-title">
						<div class="legend">
							URA
						</div>
					</div>

					<div class="container-fluid">
						<div class="row">
							
							<div class="col-md-4" v-for="i in 9" :key="i">
								<div class="form-group">
									<label>Opção {{ i }}</label>

									<select v-model="params.OPT_URA[i-1]" class="form-control">
										<option value="99">Indefinido</option>
										<option v-for="setor in setores" :key="setor.ID" :value="setor.ID" :data-audio="setor.AUDIONAME">{{ setor.NAME }}</option>
									</select>
								</div>
							</div>

						</div>
					</div>
				</fieldset>
			</div>
		</div>

		<div class="d-flex flex-row-reverse bd-highlight mb-3">
			<button @click="save" class="btn btn-sm btn-success">Salvar</button>
		</div>

	</section>
</template>

<script>
	import api from "@/mixins/api.js"

	export default {
		name: "Pabx_Config",
		mixins: [api],

		data: () => { return {
			params: { OPT_URA: [] },
			setores: {}
		}},

		created() {
			this.get_config()
			this.get_setores()
		},

		methods: {
			async get_config() {
				const response = await this.GET("Config/pabx", 1)

				if ( response.status == 'success' ) {
					this.params = response.data
					this.params.OPT_URA = response.data.OPT_URA.split(',')
				}
			},

			async get_setores() {
				const response = await this.GET("Setor?audioname=true")
				if ( response.status == 'success' ) this.setores = response.result
			},

			async save() {
				this.mount_msgura()
				this.params.OPT_URA = this.params.OPT_URA.join(",")
				const response = await this.PUT("Config/pabx", this.params)

				this.$emit('alert', response)
				this.params.OPT_URA = this.params.OPT_URA.split(',')
			},

			mount_msgura() {
				let valid = []

				this.params.OPT_URA.forEach( i => {
					if ( i != "99" ) valid.push(`${i}`)
				})

				let option = 1
				let msgura = ""

				valid.forEach( (i, index) => {
					let name = ""
					this.setores.forEach( s => { if ( s.ID == i ) name = s.AUDIONAME })

					if ( index != 0 ) msgura += "&"
					if ( index == valid.length - 1 ) msgura += "&ou&"

					msgura += name + "&dig" + option
					option++
				})

				this.params.MSG_URA = msgura
			}
		}
	}
</script>

<style>
.slidecontainer {
  width: 100%;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;   
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 50%; 
  background: #0E8E84;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #0E8E84;
  cursor: pointer;
}
</style>